import { GAME_PAGES } from '../routes/gameScopeNav.jsx';
import { GAME_WIDE_PAGES, GEOGRAPHY_PAGES } from '../config/pagePaths.generated.js';

// Whether a game page follows the header's geography (decided 9 October 2026). Geography pages - Segments, Configs,
// Event Definitions, Upcoming Events, AI Recommendations, Nitro Chat - show and change what is in the selected
// geography. Every other game page is GAME-WIDE: its data is the whole game's (Player Attributes, the game's settings,
// the metric catalogue, ...). On those the header says "Whole game" instead of offering a geography, and the server
// lets the geography add at most read access. The list itself is rbac-config.json `geographyPages`, shared with the
// server through the generated constants.

const leaves = [];
(function collect(nodes) {
    for (const node of nodes || []) {
        if (node.children) collect(node.children);
        else if (typeof node.segment === 'string') leaves.push(node);
    }
})(GAME_PAGES);

/** The game page (nav leaf) a /game/<slug>/... path is on, or null; '' is the game's Homepage. */
const leafFor = (rest) => {
    let best = null;
    for (const leaf of leaves) {
        const seg = leaf.segment;
        if (!seg) continue;
        if ((rest === seg || rest.startsWith(`${seg}/`)) && (!best || seg.length > best.segment.length)) best = leaf;
    }
    return best;
};

/**
 * 'geography' | 'game' for a game page path, null outside a game (and in the new-game wizard).
 * A path the nav does not know is game-wide: only the listed pages follow the geography.
 */
export const gamePageScope = (pathname) => {
    const parts = String(pathname || '').split('/').filter(Boolean);
    if (parts[0] !== 'game' || !parts[1] || parts[1] === 'new') return null;
    const rest = parts.slice(2).join('/');
    const leaf = rest ? leafFor(rest) : null;
    return leaf?.page && GEOGRAPHY_PAGES.includes(leaf.page) ? 'geography' : 'game';
};

/** The page's own name, for "Player Attributes applies to every player of Tetris". */
export const gamePageLabel = (pathname) => {
    const parts = String(pathname || '').split('/').filter(Boolean);
    if (parts[0] !== 'game' || !parts[1]) return null;
    const rest = parts.slice(2).join('/');
    return rest ? (leafFor(rest)?.label || null) : 'Homepage';
};

/** Whether an RBAC page id is game-wide - for the permission editor's geography scope. */
export const isGameWidePage = (pageId) => GAME_WIDE_PAGES.includes(pageId);
